<template>
    <div class="maintenance-page">
        <v-container class="fill-height" fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" md="8" lg="6">
                    <v-sheet
                        class="pa-8 text-center maintenance-page__card"
                        rounded="lg"
                        elevation="2"
                    >
                        <v-icon size="56" color="warning">mdi-tools</v-icon>
                        <h1 class="text-h4 mt-4 mb-4">{{ $t('maintenancePage.title') }}</h1>
                        <p class="text-body-1 mb-0">{{ $t('maintenancePage.description') }}</p>
                    </v-sheet>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'MaintenancePage',
};
</script>

<style scoped lang="scss">
.maintenance-page {
    min-height: 100%;
    background: linear-gradient(180deg, #f5f7fa 0%, #eef2f7 100%);
}

.maintenance-page__card {
    border: 1px solid #d8dee8;
}
</style>
